import { callCollaboratorsApi } from './collaboratorsApi';

export async function removeCollaborator(
  tourId: string,
  collaboratorUid: string,
): Promise<{ success: boolean }> {
  return callCollaboratorsApi<{ success: boolean }>({
    action: 'remove',
    tourId,
    collaboratorUid,
  });
}
